import { ApiState } from '@models/api-state';
import { ClientInfo } from 'app/core/services/benutzerprofil/models/clientInfo';
import { StoredFavoriteMerkmal } from '@models/dossier/dossier-models';
import { BenutzerProfilFavorit } from 'app/core/services/api-client';

export interface UserProfileState {
  fachlektorMerkmale: Set<number>;
  lieferantenMerkmale: Set<number>;
  apiState: ApiState;
  clientInfoHasChanged: boolean;
  clientInfo?: ClientInfo;
  favouriteMerkmale: StoredFavoriteMerkmal[];
  favoriten: BenutzerProfilFavorit[];
  isFavoritenLoading: boolean;
  isCheckingFavorit: boolean;
}

export const initialState: UserProfileState = {
  fachlektorMerkmale: new Set<number>([]),
  lieferantenMerkmale: new Set<number>([]),
  apiState: 'Unknown',
  clientInfoHasChanged: false,
  clientInfo: null,
  favouriteMerkmale: [],
  favoriten: [],
  isFavoritenLoading: false,
  isCheckingFavorit: false
};
